// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"bf8f48c9","268":"2e725fa3","293":"90bdb4ee","326":"c6979bb1","456":"cdc9ad09","520":"4c2b5ef1","534":"1b427e5f","664":"1e3be2ca","680":"0f24693a","743":"3f4ba586","747":"c1dd3d36","796":"e26b62a3","829":"46220245","854":"eafef090","912":"948cbc45"}[chunkId] + ".chunk.js";
};